<template>
  <div>
    <div class="fixed">
      <transition name="fade">
        <div class="alert alert-danger" role="alert" v-if="resetFail">
          <span style="font-style: italic; font-weight: bold"> Incorrect Email! Please use correct email! </span>
        </div>
      </transition>
      <transition name="fade">
        <div class="alert alert-success" role="alert" v-if="resetSuccess">
          <span style="font-style: italic; font-weight: bold">Please check your email. A reset link has been sent to your email! </span> Redirecting to Login ...
        </div>
      </transition>
    </div>
    <div class="action">
      <CCard style="min-width: 30%">
        <CCardHeader align="center">
          <strong>EXODUS Reset Password </strong><small>Form</small>
        </CCardHeader>
        <CCardBody>
          <CInput
              v-model="email"
              type="email"
              label="Email"
              placeholder="user@example.com"
          />
        </CCardBody>
        <CCardFooter>
          <div class="card_footer">
            <CButton type="submit" class="mx-3" color="primary" @click="requestResetPassword">Send Password Reset Link</CButton>
          </div>
        </CCardFooter>
      </CCard>
    </div>
    <div id="footer">
      <TheFooter/>
    </div>
  </div>
</template>

<script>
import TheFooter from "@/containers/TheFooter";
import axios from "axios";
export default {
  name: "ForgotPassword",
  components: {TheFooter},
  data() {
    return {
      email: null,
      resetFail: false,
      resetSuccess: false
    }
  },
  methods: {
    requestResetPassword() {
      let self = this;
      const postData = {
        email: self.email
      };

      axios.post(this.$apiAdress + '/api/forgot-password', postData, {
        headers: {
          Accept: 'application/json',
        }
      })
      .then(function (response) {
        console.log('forgot-password', response)
        self.resetSuccess = true
        self.resetFail = false

        setTimeout(function () {
          self.$router.push({ path: '/login' });
        }.bind(this), 5000);

      }).catch(function (error) {
        console.log(error)
        self.email = ''
        self.resetFail = true;

        setTimeout(function () {
          self.resetFail = !self.resetFail
        }.bind(this), 5000);
      });
    }
  }
}
</script>

<style scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  /*height: 100vh;*/
  margin-top: 10%;
}

#footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.fixed {
  position: fixed;
  width: 20%;
  bottom: 10px;
  z-index: 1;
  right: 2%;
}
</style>
